<template>
  <div id="main-content" class="detail-sub-driver">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToEdit()">{{ $t('common.edit') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <form>
        <el-row>
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.full_name') }}:</span>
            <span class="info-span"> {{ notificationGroupInfo.name }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.type') }}:</span>
            <span class="info-span" v-if="notificationGroupInfo.type == 1">{{ $t('common.sub_driver') }}</span>
            <span class="info-span" v-else>{{ $t('common.parent') }}</span>
          </el-col>
        </el-row>
        <el-row v-if="notificationGroupInfo.type == 2" class="row-section">
          <h3>{{ $t('parent_list.parent_list') }}</h3>
        </el-row>
        <el-row v-if="notificationGroupInfo.type == 2" style="">
          <div v-for="(parent, index) in parentListData" :key="parent.id">
            <el-col :span="8" style="display: inline;">
              <span class="form-lable">{{ $t('common.parent') }} {{ index+1 }}:</span>
              <span class="info-span">{{ getParentName(parent) }}</span>
            </el-col>
            <el-col :offset="1" :span="8">
              <span class="form-lable">{{ $t('common.email') }}:</span>
              <span class="info-span">{{ parent.email }}</span>
            </el-col>
          </div>
        </el-row>

        <el-row v-if="notificationGroupInfo.type == 1" class="row-section">
          <h3>{{ $t('sub_driver.sub_driver_list') }}</h3>
        </el-row>
        <el-row v-if="notificationGroupInfo.type == 1" style="">
          <div v-for="(sub, index) in subListData" :key="sub.id">
            <el-col :span="11" style="display: inline">
              <span class="form-lable">{{ $t('common.sub_driver') }} {{ index+1 }}:</span>
              <span class="info-span">{{ sub.name }}</span>
            </el-col>
            <el-col :offset="1" :span="8">
              <span class="form-lable">{{ $t('common.email') }}:</span>
              <span class="info-span">{{ sub.email }}</span>
            </el-col>
          </div>

        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "DetailAdminNotificationGroup",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/notification-group`,
        title: 'notification.notification_group_information',
        parentList: []
      }
    },
    mounted: function () {
      let successCallback = () => {
      };
      let payload = {
        successCallback,
        admin_notification_group_id: this.$route.query.nid
      }
      this.$store.dispatch('notificationgroup/getNotificationGroupInfo', payload)
      this.$store.dispatch('subdriver/retrieveSubDriverList', {})

      let parentPayload = {
        successCallback: (response) => {
          this.parentList = [].concat(response.data.data.parent_list)
        }
      }

      this.$store.dispatch('notification/retrieveParentList', parentPayload)
    },
    computed: {
      ...mapState('notificationgroup', ['notificationGroupInfo']),
      ...mapState('subdriver', ['subDriverList']),
      parentListData: function() {
        if (this.notificationGroupInfo.type === 2 ) {
          var parentIds = this.notificationGroupInfo.member_ids.split(',')
          var parentInfo = []
          for (const [key, value] of Object.entries(parentIds)) {
            if (this.parentList[this.parentList.findIndex(x => x.id == value)] != undefined) {
              parentInfo.push(this.parentList[this.parentList.findIndex(x => x.id == value)])
            }
          }
        }
        return parentInfo
      },
      subListData: function () {
        if (this.notificationGroupInfo.type === 1 ) {
          var subIds = this.notificationGroupInfo.member_ids.split(',')
          var subInfo = []
          for (const [key, value] of Object.entries(subIds)) {
            if (this.subDriverList[this.subDriverList.findIndex(x => x.id == value)] != undefined) {
              subInfo.push(this.subDriverList[this.subDriverList.findIndex(x => x.id == value)])
            }
          }
          return subInfo
        }
        return []
      }
    },
    methods: {
      goToEdit: function () {
        this.$router.push({path: '/notification-group/edit', query: {nid: this.$route.query.nid}});
      },
      getParentName: function (parent) {
        let id = parent.id.toString().split('_')
        let label = `${parent.name}`

        if (id.length > 1) {
          label += ` (${this.$t('common.partner')})`
        }

        return label
      }
    }
  }
</script>

<style lang="scss">
</style>
